import BlogSlider from '@/components/landing/BlogSlider';
import CostComparison from '@/components/landing/CostComparison';
import FAQ from '@/components/landing/FAQ';
import HowItWorks from '@/components/landing/Features';
import GetStartedSection from '@/components/landing/GetStartedSection';
import Hero from '@/components/landing/Hero';
import ProductCards from '@/components/landing/ProductCards';
import PromoBanner from '@/components/landing/PromoBanner';
import Reviews from '@/components/landing/Reviews';
import { setPageMetadata } from '@/lib/utils';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/_public/')({
  component: LandingPage
})

export default function LandingPage() {
  useEffect(() => {
    setPageMetadata({
      title: 'AI-Powered Home Selling | Save $20,000+ | Swim Homes Canada',
      description: 'Swim\'s AI-powered platform helps Canadian homeowners sell without realtors, saving $20,000+ on commissions. MLS® listings start at $599 with 24/7 AI agent support.',
    });
  }, []);

  return (
    <div className='relative z-10 mx-auto px-8 max-w-7xl space-y-20 overflow-visible'>
      <PromoBanner />
      <Hero />
      <GetStartedSection />
      <HowItWorks />
      <Reviews />
      <ProductCards />
      <CostComparison />
      <BlogSlider />
      <FAQ />
    </div>
  );
}